import React, { useEffect, useRef, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createProductStart, getProductStart, resetProductState, updateProductStart } from "../../../Store/Slices/promptSlice";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";
import Toast from "../../../Components/Toast";

const ProductFiles = () => {
    const dispatch = useDispatch();
    let promptData = useSelector((state) => state?.prompt);
    let productsList = promptData?.productsData?.[0]?.products_data;
    const textareaRefs = useRef({});
    let [productsData, setProductsData] = useState([
        {
            product_name: '',
            product_detail: ''
        }
    ]);

    useEffect(() => {
        dispatch(getProductStart())
    }, [])

    useEffect(() => {
        if (!productsList?.length) {
            let newItem = {
                product_name: '',
                product_detail: ''
            }
            setProductsData([newItem])
        } else {
            setProductsData(productsList)
        }
    }, [productsList])

    useEffect(() => {
        const resizeAll = () => {
            productsData.forEach((item, index) => autoResize(index));
        };
        // Listen for the custom event
        window.addEventListener('productFilesTabShown', resizeAll);

        // Also run once if already visible
        resizeAll();

        return () => {
            window.removeEventListener('productFilesTabShown', resizeAll);
        };
    }, [productsData]);

    useEffect(() => {
        if (promptData?.createProductStatus) {
            setProductsData(promptData?.createProductData?.products_data)
            toast.success(promptData.message, {
                autoClose: 2000,
                onClose: () => {
                    dispatch(resetProductState())
                }
            });
        }
        if (promptData?.updateProductStatus) {
            setProductsData(promptData?.updateProductData?.products_data)
            toast.success(promptData.message, {
                autoClose: 2000,
                onClose: () => {
                    dispatch(resetProductState())
                }
            });
        }
        if (promptData?.createProductStatus === false || promptData?.updateProductStatus === false) {
            toast.error(promptData.message, {
                autoClose: 2000,
                onClose: () => {
                    dispatch(resetProductState())
                }
            });
        }
    }, [promptData?.createProductStatus, promptData?.updateProductStatus])

    const autoResize = (inx) => {
        const textarea = textareaRefs.current[inx];
        if (textarea) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    const formHandler = (e, index) => {
        try {
            const { name, value } = e?.target;
            const updatedProduct = productsData.map((item, i) =>
                i === index ? { ...item, [name]: value } : item
            );
            setProductsData(updatedProduct);

            if (name === 'product_detail') {
                autoResize(index)
            }
        } catch (err) {
            throw err;
        }
    }

    const addHandler = () => {
        const newProduct = {
            product_name: '',
            product_detail: ''
        }
        setProductsData([...productsData, newProduct]);
    }

    const removeHandler = (index) => {
        setProductsData(productsData.filter((_, i) => i !== index));
    }

    const handleSave = () => {
        if (productsData?.length > 0) {
            let payload = {
                products_data: productsData
            }
            dispatch(createProductStart(payload))
        }
    }

    const handleUpdate = () => {
        let id = promptData?.productsData?.[0]?._id
        if (productsData?.length > 0) {
            let payload = {
                products_data: productsData
            }
            dispatch(updateProductStart({ id: id, payload: payload }))
        }
    }

    return (
        <>
            <Toast />
            <Loader isVisible={promptData?.isLoading} />
            <React.Fragment>
                <div style={{ flexGrow: 1, overflowY: 'auto' }}>
                    <div className='pt-3'>
                        <div className='d-flex flex-row justify-content-between pb-3'>
                            <h5 className='fw-semibold'>Product Files</h5>
                            {promptData?.productsData?.length === 0 ?
                                <button type="button" class="btn btn-primary btn-blue" onClick={handleSave}>
                                    <span>Save</span>
                                </button>
                                :
                                <button type="button" class="btn btn-primary btn-blue" onClick={handleUpdate}>
                                    <span>Update</span>
                                </button>
                            }
                        </div>

                        <div className="mt-3">
                            {productsData.map((data, index) => (
                                <Row className="mt-2 m-0">
                                    <div className="col-4 mb-3 form-fields-page">
                                        <div className=" form-floating">
                                            <input type="text"
                                                className="form-control"
                                                placeholder="Product"
                                                name="product_name"
                                                value={data.product_name}
                                                onChange={(e) => formHandler(e, index)}
                                            />
                                            <label className="d-inline-block">Product</label>
                                        </div>
                                    </div>

                                    <div className="col-7 mb-3 form-fields-page">
                                        <div className="form-floating">
                                            <textarea className="form-control"
                                                rows="1"
                                                placeholder="Produce Details"
                                                name="product_detail"
                                                ref={(el) => (textareaRefs.current[index] = el)}
                                                value={data.product_detail}
                                                onChange={(e) => formHandler(e, index)}
                                                style={{ overflow: "hidden", resize: "none" }}></textarea>
                                            <label className="d-inline-block">Product Details</label>
                                        </div>
                                    </div>

                                    <div className="col-1 d-flex">
                                        {index === (productsData.length - 1) && (
                                            <button type="button"
                                                className="btn btn-light rounded-circle p-0 me-2"
                                                style={{ border: '3px solid rgb(240 234 234)', height: '30px', width: '30px' }}
                                                title="New Product"
                                                onClick={() => addHandler()}>+</button>
                                        )}

                                        {productsData.length > 1 && (
                                            <button type="button"
                                                className="btn btn-light rounded-circle p-0"
                                                style={{ border: '3px solid rgb(240 234 234)', height: '30px', width: '30px' }}
                                                title="Remove Product"
                                                onClick={() => removeHandler(index)}>-</button>
                                        )}
                                    </div>
                                </Row>
                            ))}
                        </div>
                    </div>
                </div>
                {/* <div className="mt-3 text-end">
                    {productsList?.length === 0 ?
                        <button type="button" class="btn btn-primary btn-blue" onClick={handleSave}>
                            <span>Save</span>
                        </button>
                        :
                        <button type="button" class="btn btn-primary btn-blue" onClick={handleUpdate}>
                            <span>Update</span>
                        </button>
                    }
                </div> */}
            </React.Fragment>
        </>
    )
}
export default ProductFiles;